import React from 'react';
import { useContextMenuState } from './useContextMenuState';
import { Pointer } from '@yleisradio/areena-types';

type Props = {
  title?: string;
  info?: string;
  labels?: string;
};

export const ContextMenuContextProvider: React.FC<
  React.PropsWithChildren<Props>
> = ({ children }) => {
  const {
    openContextMenu,
    closeContextMenu,
    isOpen,
    menuSource,
    title,
    info,
    labels,
  } = useContextMenuState();

  return (
    <ContextMenuContext.Provider
      value={{
        openContextMenu,
        closeContextMenu,
        isContextMenuOpen: isOpen,
        contextMenuSource: menuSource,
        title,
        info,
        labels,
      }}
    >
      {children}
    </ContextMenuContext.Provider>
  );
};

export const useContextMenuContext = () => React.useContext(ContextMenuContext);

export type Value = {
  openContextMenu: (
    menuSource: Pointer,
    title: string,
    info?: string,
    labels?: string
  ) => void;
  closeContextMenu: () => void;
  isContextMenuOpen: boolean;
  contextMenuSource?: Pointer;
  title?: string;
  info?: string;
  labels?: string;
};

const errMsg = 'ContextMenu context called outside Provider';

const defaultValue: Value = {
  openContextMenu: () => {
    throw new Error(errMsg);
  },
  closeContextMenu: () => {
    throw new Error(errMsg);
  },
  isContextMenuOpen: false,
  contextMenuSource: undefined,
};

export const ContextMenuContext = React.createContext<Value>(defaultValue);
